import React from "react";
import type { GatsbyBrowser } from "gatsby";

import { ThemeProvider } from "./src/context/ThemeContext";
import CookieConsent from "./src/components/CookieConsent";
import "./src/styles/global.css";

// Owijamy całą aplikację w ThemeProvider - dostęp do useTheme() wszędzie
export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({ element }) => {
  return <ThemeProvider>{element}</ThemeProvider>;
};

// Baner cookies na każdej stronie (poza element, by nie znikał przy nawigacji SPA)
export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({ element }) => {
  return (
    <>
      {element}
      <CookieConsent />
    </>
  );
};

// Ustaw dark mode jako domyślny PRZED hydratacją - unika flash of unstyled content
export const onClientEntry: GatsbyBrowser["onClientEntry"] = () => {
  if (typeof window === "undefined") return;
  const stored = window.localStorage.getItem("theme");
  if (stored === "light") {
    document.documentElement.classList.remove("dark");
  } else {
    document.documentElement.classList.add("dark");
  }
};
